import { useEffect } from 'react';
import { EnabledRepositoriesStatus, Step } from 'shared/InstallationDialog';
import { useMultiStepDialog } from 'shared/MultiStepDialog';
import { renderTranslations, spawn } from 'utils/translations';
import { useBitbucketInstallation } from '../bitbucketInstallationContext';
import { ENABLE_QODO_TRANSLATION_KEY } from '../consts';

const spawnEnable = spawn(ENABLE_QODO_TRANSLATION_KEY);

export const EnableQodo = () => {
  const {
    currentStepIndex,
    setCurrentStepAsFurthestStepReached,
    setEarliestStepAvailable,
  } = useMultiStepDialog();

  const { webhookResults } = useBitbucketInstallation();

  const connectedCount = webhookResults.filter(
    (r) => r.status === 'installed',
  ).length;

  useEffect(() => {
    setCurrentStepAsFurthestStepReached();
    setEarliestStepAvailable(currentStepIndex);
  }, [
    currentStepIndex,
    setCurrentStepAsFurthestStepReached,
    setEarliestStepAvailable,
  ]);

  return (
    <Step
      title={spawnEnable('title')}
      description={renderTranslations(
        `${ENABLE_QODO_TRANSLATION_KEY}.description`,
      )}
    >
      <div className="flex flex-col gap-8">
        <EnabledRepositoriesStatus
          title={spawnEnable('enabled-message', { count: connectedCount })}
          description={spawnEnable('enabled-description')}
        />
      </div>
    </Step>
  );
};
